export class AbhollisteFilter {
    minAlter: number;
    maxAlter: number;
    geschlechterIds: number[] = [];
    rassenIds: number[] = [];
    datum: Date;
    nichtInAbholliste: boolean;
    historie: boolean;
    toteAnzeigen: boolean;
}
